import { render, staticRenderFns } from "./InsideNotice.vue?vue&type=template&id=12a14db1&scoped=true&"
import script from "./InsideNotice.vue?vue&type=script&lang=ts&"
export * from "./InsideNotice.vue?vue&type=script&lang=ts&"
import style0 from "./InsideNotice.vue?vue&type=style&index=0&id=12a14db1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a14db1",
  null
  
)

export default component.exports